const Hero = ({ data }) => (
  <section className="hero-grid ml-auto mr-auto pt5 mw8">
    <Greeting heading={data.heading} paragraph={data.paragraph} />
    <Balls image={data.image.childImageSharp.sizes} alt={data.alt} critical={data.critical} />
  </section>
)

export default Hero

/*
 *
 * General
 * 
 */

import React from 'react'

/*
 *
 * Greeting
 * 
 */

import LearnMore from '../components/LearnMore'

const Greeting = ({ heading, paragraph }) => (
  <div className="ph3 md:ph4 lg:ph5">
    <h2 className="heading mb4">
      <span className="pre-line light-gray">{heading.gray}</span>{' '}
      <span className="gold">{heading.gold}</span>
    </h2>
    <p className="mb4 measure-narrow lh-copy f-lead">{paragraph}</p>
    <LearnMore className="btn mb5" />
  </div>
)

/*
 *
 * Balls
 * 
 */

import Ball from '../components/Ball'
import Img from '../components/Img'

const Balls = ({ image, alt, critical }) => (
  <figure role="group" className="relative ml-auto pt5 pb6 mw6">
    <Img
      sizes={image}
      alt={alt}
      critical={true}
      className="ml-auto w-90"
      style={{ transform: `translateX(.9rem)` }}
    />

    <Ball className="top-40 left-60 anim-diagonal-right bg-gold w2 h2" />
    <Ball className="top-20 left-70 anim-horizontal bg-gray w1 h1" />
    <Ball className="top-20 left-40 anim-vertical anim-delay-1 bg-gold w2 h2" />
    <Ball className="top-30 left-30 anim-horizontal anim-delay-3 bg-gray w1 h1" />
    <Ball className="top-50 left-50 anim-diagonal-left anim-delay-3 bg-gold w2 h2" />
    <Ball className="top-75 left-60 anim-diagonal-left anim-delay-2 bg-gray w1 h1" />
    <Ball className="top-50 left-30 anim-horizontal anim-delay-1 bg-gold w2 h2" />
    <Ball className="top-50 left-20 anim-vertical anim-delay-3 bg-gray w1 h1" />
    <Ball className="top-70 left-80 anim-vertical anim-delay-3 bg-gold w2 h2" />
  </figure>
)



// WEBPACK FOOTER //
// ./src/sections/Hero.js